import React from 'react';
import { List, Form } from 'semantic-ui-react'
// import {graphql} from 'react-apollo';

//utils
// import queries from '../../../src/utils/queries'

import TitDer from '../../components/funcionales/titder';

// import general from '../../modulos/general';

//dropdown EMPRESAS
const DetalleEmpNivel1 = props => {
  return (
    <option style={props.styles.input}>{props.elemento.descrEmpresa}</option>
  )
};

const ListaEmp = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleEmpNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrEmpresa" id="miLista" onChange={(ev)=>handleChange(ev)}>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown EMPRESAS

//Lista de mecanismos
const DetallePl = ({elemento, handleClickidLista, idListaP}) => {
  let colorCelda='white'
  if(elemento.estado==='PELIGRO'){
    colorCelda = 'red'
  }else{
    if(elemento.estado==='ALARMA'){
      colorCelda = 'yellow'
    }else{
      if(elemento.estado==='CONFIABLE'){
        colorCelda = 'green'
      }
    }
  }
  let urlSlcm = 'https://montserratslcm.com/api/laboratorio/'
  let urlSlcmPDF = 'https://montserratslcm.com/api/cartas/'
  return(

    <tr className=''>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#ffffff'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.descrPlanta}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#ffffff'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.descrSeccion}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#ffffff'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.descrEquipo}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: '#0000EE', 
              background: '#ffffff'}}>
        <a style={{color: '0000EE'}}
          href={urlSlcmPDF + elemento.descrEmpresa + '_' + elemento.descrPlanta + '_' + elemento.descrSeccion + '_' + elemento.descrEquipo + '.pdf'}
            target="_blank">
          {'PDF'}
        </a>
      </td>        
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#ffffff'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.descrComponente}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#ffffff'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.descrMecanismo}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#ffffff'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.descrAplicacion}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#ffffff'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.descrLubricante}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#ffffff'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.ultInforme}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.estado}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#ffffff'}}>
        <a style={{color: 'black'}}
          href={urlSlcm + elemento.nomArchivo}
            target="_blank">
          {elemento.nomArchivo}
        </a>
      </td>
  </tr>



  )
};

const ListaPl = ({list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetallePl elemento={elemento} handleClickidLista={handleClickidLista}
        key={i}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};
//FIN Lista de mecanismos

class HomePr2 extends React.Component {

  render(){
        
  // console.log(this.props.list)
  //Traer autorizaciones
  const a01 = this.props.autorizacUA.findIndex( autorizac => autorizac === "01" );
  const a0101 = this.props.autorizacUA.findIndex( autorizac => autorizac === "0101" );
  // const a010101 = autorizacUA.findIndex( autorizac => autorizac === "010101" );
  
  // let list = list
  // let list1 = list1
// console.log(this.props.list1)
  return (
    <div>
      {a01!==-1 &&
      <List selection>
        {/* <TitDer list={list} textBoton1="Empresas" btnNuevo={a010101!==-1?"SI":"NO"} styles={styles} handleClick={handleClick} /> */}
        <TitDer list={this.props.list} textBoton1="Empresas" btnNuevo={"NO"} styles={this.props.styles}/>

        <div>
          <div className="ui two column stackable grid">
            <div className="row container">
              <div className="column" style={{width: '50%', paddingLeft: '1.2em'}}>
                <Form.Field>
                  <ListaEmp styles={this.props.styles} list={this.props.list1}
                    handleChange={this.props.handleChange} /> 
                </Form.Field>
              </div>
            </div>
          </div>
            {/* <div style={{height: '20em', overflow: 'auto'}}> */}
              <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                <thead className=''>
                  <tr className=''>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>Planta</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Sección</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Equipo</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Carta Lub. Equipo</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>Componente</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>Mecanismo</th>
                    {/* <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>QR</th> */}
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>Aplicación / Espesante</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>Lubricante</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Ult. Inf.</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>estado</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Informe de lab.</th>
                  </tr>
                </thead>
                <ListaPl list={this.props.list} handleClickidLista={a0101!==-1?this.props.handleClickidLista:()=>{}}/>
              </table>
              <p></p>
            {/* </div> */}
          </div>
      </List>
      }
    </div>
  )
      }
};

export default HomePr2
